// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/NoGiJiuJitsuWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 노기 주짓수 체급 (-25kg ~ +90kg 15체급)
 *
 * 체급표는 한 장이다 — 초 · 중 · 고 · 일반부와 남 · 여가 같은 경계를 쓴다.
 * 부 · 성별은 대진표 키에 따로 들어가므로 「초등부 남자 -25kg」 대진표로 갈린다.
 */
export enum NoGiJiuJitsuWeightClassPayload {
  NO_GI_WEIGHT_CLASS_UNKNOWN = 0,
  /** NO_GI_MINUS_25 - -25kg */
  NO_GI_MINUS_25 = 1,
  /** NO_GI_MINUS_30 - -30kg */
  NO_GI_MINUS_30 = 2,
  /** NO_GI_MINUS_35 - -35kg */
  NO_GI_MINUS_35 = 3,
  /** NO_GI_MINUS_40 - -40kg */
  NO_GI_MINUS_40 = 4,
  /** NO_GI_MINUS_45 - -45kg */
  NO_GI_MINUS_45 = 5,
  /** NO_GI_MINUS_50 - -50kg */
  NO_GI_MINUS_50 = 6,
  /** NO_GI_MINUS_55 - -55kg */
  NO_GI_MINUS_55 = 7,
  /** NO_GI_MINUS_60 - -60kg */
  NO_GI_MINUS_60 = 8,
  /** NO_GI_MINUS_65 - -65kg */
  NO_GI_MINUS_65 = 9,
  /** NO_GI_MINUS_70 - -70kg */
  NO_GI_MINUS_70 = 10,
  /** NO_GI_MINUS_75 - -75kg */
  NO_GI_MINUS_75 = 11,
  /** NO_GI_MINUS_80 - -80kg */
  NO_GI_MINUS_80 = 12,
  /** NO_GI_MINUS_85 - -85kg */
  NO_GI_MINUS_85 = 13,
  /** NO_GI_MINUS_90 - -90kg */
  NO_GI_MINUS_90 = 14,
  /** NO_GI_PLUS_90 - +90kg */
  NO_GI_PLUS_90 = 15,
  UNRECOGNIZED = -1,
}

export function noGiJiuJitsuWeightClassPayloadFromJSON(object: any): NoGiJiuJitsuWeightClassPayload {
  switch (object) {
    case 0:
    case "NO_GI_WEIGHT_CLASS_UNKNOWN":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "NO_GI_MINUS_25":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_25;
    case 2:
    case "NO_GI_MINUS_30":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_30;
    case 3:
    case "NO_GI_MINUS_35":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_35;
    case 4:
    case "NO_GI_MINUS_40":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_40;
    case 5:
    case "NO_GI_MINUS_45":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_45;
    case 6:
    case "NO_GI_MINUS_50":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_50;
    case 7:
    case "NO_GI_MINUS_55":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_55;
    case 8:
    case "NO_GI_MINUS_60":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_60;
    case 9:
    case "NO_GI_MINUS_65":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_65;
    case 10:
    case "NO_GI_MINUS_70":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_70;
    case 11:
    case "NO_GI_MINUS_75":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_75;
    case 12:
    case "NO_GI_MINUS_80":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_80;
    case 13:
    case "NO_GI_MINUS_85":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_85;
    case 14:
    case "NO_GI_MINUS_90":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_90;
    case 15:
    case "NO_GI_PLUS_90":
      return NoGiJiuJitsuWeightClassPayload.NO_GI_PLUS_90;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NoGiJiuJitsuWeightClassPayload.UNRECOGNIZED;
  }
}

export function noGiJiuJitsuWeightClassPayloadToJSON(object: NoGiJiuJitsuWeightClassPayload): string {
  switch (object) {
    case NoGiJiuJitsuWeightClassPayload.NO_GI_WEIGHT_CLASS_UNKNOWN:
      return "NO_GI_WEIGHT_CLASS_UNKNOWN";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_25:
      return "NO_GI_MINUS_25";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_30:
      return "NO_GI_MINUS_30";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_35:
      return "NO_GI_MINUS_35";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_40:
      return "NO_GI_MINUS_40";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_45:
      return "NO_GI_MINUS_45";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_50:
      return "NO_GI_MINUS_50";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_55:
      return "NO_GI_MINUS_55";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_60:
      return "NO_GI_MINUS_60";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_65:
      return "NO_GI_MINUS_65";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_70:
      return "NO_GI_MINUS_70";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_75:
      return "NO_GI_MINUS_75";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_80:
      return "NO_GI_MINUS_80";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_85:
      return "NO_GI_MINUS_85";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_MINUS_90:
      return "NO_GI_MINUS_90";
    case NoGiJiuJitsuWeightClassPayload.NO_GI_PLUS_90:
      return "NO_GI_PLUS_90";
    case NoGiJiuJitsuWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
